import { useNavigate, Link } from 'react-router-dom';
import {Navbar, Nav, Container, NavDropdown, Form, FormGroup} from 'react-bootstrap';
import {useState, useEffect} from 'react';
import {LinkContainer} from 'react-router-bootstrap';
import logo from '../assets/DOC_Logo_md.png';
import { useSelector, useDispatch } from 'react-redux';
import { useLogoutMutation } from '../slices/usersApiSlice';
import {logout} from '../slices/authSlice';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { useSiteSearchMutation } from '../slices/sitesApiSlice';
import { handleUnauthorized } from '../utils/auth';

const Header = () => {
  const {userInfo} = useSelector((state) => state.auth);
  const [options, setOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const[siteSearch] = useSiteSearchMutation();

  const siteSearchChange = async (event) => {
    const {value} = event.target;
    setSearchValue(value);
    const res = await siteSearch({searchTerm: value})
    console.log(res);
    if (res && Array.isArray(res.data)) {
      setOptions(res.data);
      setShowDropdown(true);
    } else {
      setOptions([]);
      setShowDropdown(false);
    }
    console.log(options)
  }
  const handleFocus = () => {
    document.getElementById('siteSearchInput').value = '';
    setSearchValue('');
    setShowDropdown(false);
  };

  const handleMouseDown = (event) => {
    event.preventDefault();
  };

  const formatDropdownItem = (site, searchTerm) => {
    const colonIndex = searchTerm.indexOf(':');
    if (colonIndex > 0) {
      const fieldKey = searchTerm.substring(0, colonIndex).trim().toLowerCase();
      const rawValue = searchTerm.substring(colonIndex + 1).trim();
      
      if (rawValue) {
        switch (fieldKey) {
          case 'address':
            return `${site.name} (${site.locationAddress?.address || ''})`;
          case 'city':
            return `${site.name} (${site.locationAddress?.city || ''})`;
          case 'zip':
          case 'postal':
          case 'postalcode':
            return `${site.name} (${site.locationAddress?.postalCode || ''})`;
          case 'firewall':
          case 'mainfirewallip':
            return `${site.name} (Firewall: ${site.mainFirewallIP || ''})`;
          case 'ip':
          case 'iprange':
            return `${site.name} (IP: ${site.ipRange || ''})`;
          case 'abbr':
          case 'abbreviation':
            return `${site.name} (${site.abbr || ''})`;
          case 'company':
            return `${site.name} (${site.company || ''})`;
          case 'phone':
          case 'phonenumber':
            return `${site.name} (${site.phoneNumber || ''})`;
          case 'contact':
          case 'contactname':
            return `${site.name} (Contact: ${site.contactName || ''})`;
          case 'bgp':
            return `${site.name} (BGP: ${site.BGP || ''})`;
          case 'as':
            return `${site.name} (AS: ${site.AS || ''})`;
          default:
            return site.name;
        }
      }
    }
    return site.name;
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try{
      await logoutApiCall().unwrap();
      dispatch(logout());
      navigate('/login');
    }catch(error){
      console.log(error);
    }
  }



  return (
    <header>
    
      <Navbar expand="lg" collapseOnSelect>
        <Container fluid>
          <LinkContainer to='/'>
            <Navbar.Brand>
                <img src={logo} alt="DOC Logo"/>
                <div className='header-text'>SiteBible</div>
            </Navbar.Brand>
          </LinkContainer>
          {userInfo && (
            <FormGroup className="d-flex headerSearch">
              <Form.Control
                type="search"
                list='sites'
                id='siteSearchInput'
                placeholder="Site Search"
                className="me-2"
                onChange={siteSearchChange}
                onBlur={handleFocus}
                aria-label="Search"
              />
                 {showDropdown && (
                <div className="custom-dropdown">
                  {options.map((site) => (
                    <Link reloadDocument key={site._id} to={`/sites/${site._id}`} className="dropdown-item" onMouseDown={handleMouseDown}>
                      {formatDropdownItem(site, searchValue)}
                    </Link>
                  ))}
                </div>
              )}
            </FormGroup>
          )}
       
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                  {userInfo && (
                    <>
                      <LinkContainer to='/sites'>
                        <Nav.Link>Sites</Nav.Link>
                      </LinkContainer>
                      <LinkContainer to='/reps'>
                        <Nav.Link>Reps</Nav.Link>
                      </LinkContainer>  
                      <LinkContainer to='/problems'>
                        <Nav.Link>Problems</Nav.Link>
                      </LinkContainer> 
                      <LinkContainer to='/reports'>
                        <Nav.Link>Inventory</Nav.Link>
                      </LinkContainer>
                      <LinkContainer to='/infrastructure'>
                        <Nav.Link>Infrastructure</Nav.Link>
                      </LinkContainer>
                      <LinkContainer to='/tickets'>
                        <Nav.Link>Tickets</Nav.Link>
                      </LinkContainer>
                      <LinkContainer to='/dms'>
                        <Nav.Link>DMS</Nav.Link>
                      </LinkContainer>
                    </>
                  )}
                  {userInfo ? (
                    <NavDropdown title={userInfo.name} id='username'>
                      <LinkContainer to='/profile'>
                        <NavDropdown.Item>Account</NavDropdown.Item>
                      </LinkContainer>
                      {userInfo.isAdmin && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Header>Admin</NavDropdown.Header>
                          <LinkContainer to='/admin/users'>
                            <NavDropdown.Item>Users</NavDropdown.Item>
                          </LinkContainer>
                          <NavDropdown.Divider />
                        </>
                      )}
                      <NavDropdown.Item onClick={logoutHandler}>Logout</NavDropdown.Item>
                    </NavDropdown>
                  ) : (
                    <LinkContainer to="/login">
                      <Nav.Link>Sign In</Nav.Link>
                    </LinkContainer>
                  )}
                </Nav>
            </Navbar.Collapse>
        </Container>
      </Navbar>
      
    </header>
  )
}

export default Header
